"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var _decorators_1 = require("../../_decorators");
var carrental_const_1 = require("./carrental.const");
/**
 * CarrentalService
 * @class
 */
var CarrentalService = /** @class */ (function () {
    function CarrentalService() {
    }
    /**
     * Returns a vehicleVin summary for a given vin number
     * @param vehicleVin {string}
     */
    CarrentalService.prototype.getVehicleSummary = function (vehicleVin) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getVehicleSummary.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicleVin details for a given vin number
     * @param vehicleVin {string}
     */
    CarrentalService.prototype.getVehicle = function (vehicleVin) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getVehicle.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicleVin GreenWay status for a given vin number
     * @param vehicleVin {string}
     */
    CarrentalService.prototype.getVehicleGWStatus = function (vehicleVin, query) {
        if (query === void 0) { query = ''; }
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getVehicleStatusHistory
            .replace('{{vehicleVin}}', vehicleVin)
            .replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a vehicleVin Fuel level history for a given vin number
     * @param vehicleVin {string}
     * @param query {string}
     * @deprecated since version 0.2.0
     */
    CarrentalService.prototype.getVehicleTelemetry = function (vehicleVin, query) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getVehicleMeasurements
            .replace('{{vehicleVin}}', vehicleVin)
            .replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves a reading status for vehicleVin Fuel and Mileage
     * @param vehicleVin `string`
     */
    CarrentalService.prototype.getVehicleReadingsValidation = function (vehicleVin) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.vehicleReadingsValidation.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates a reading status for vehicleVin Fuel or Mileage
     * @param vehicleVin `string`
     */
    CarrentalService.prototype.postVehicleReadingsValidation = function (vehicleVin, data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.vehicleReadingsValidation.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Retrieves an alert details for a vehicle based on vehicle Registration number
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     */
    CarrentalService.prototype.getAlertDetails = function (vehicleUuid, alertUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getAlertDetails
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Sets the alert status to `Closed`
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     */
    CarrentalService.prototype.postCloseAlert = function (vehicleUuid, alertUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.postCloseAlert
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid);
        return axios_client_service_1.axiosClientInstance.post(url);
    };
    /**
     * Retrieves a list of comments for an alert of a vehicle
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     */
    CarrentalService.prototype.getComments = function (vehicleUuid, alertUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getComments
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Adds a new comment to the  list of comments for an alert of a vehicle
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     */
    CarrentalService.prototype.postComments = function (vehicleUuid, alertUuid, data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.postComment
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updates an existing comment to the  list of comments for an alert of a vehicle
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     * @param commentUuid `string`
     * @param data `any`
     */
    CarrentalService.prototype.putComment = function (vehicleUuid, alertUuid, commentUuid, data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.putComment
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid)
            .replace('{{commentUuid}}', commentUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes an existing comment
     * @param vehicleUuid `string`
     * @param alertUuid `string`
     * @param commentUuid `string`
     */
    CarrentalService.prototype.deleteComment = function (vehicleUuid, alertUuid, commentUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.deleteComment
            .replace('{{vehicleUuid}}', vehicleUuid)
            .replace('{{alertUuid}}', alertUuid)
            .replace('{{commentUuid}}', commentUuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Sends a request to show vehicle's location along with reason
     * @param vehicleUuid `string`
     * @param data `string`
     */
    CarrentalService.prototype.postShowLocation = function (vehicleUuid, data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.postShowLocation.replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Retrieves a list of all locations - vehicles and stations
     * @returns
     */
    CarrentalService.prototype.getMapLocationsList = function (query) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getMapLocationsList.replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves a location details (station or other POI)
     * @param locationUuid `string`
     */
    CarrentalService.prototype.getMapLocationDetails = function (locationUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getMapLocationDetails.replace('{{locationUuid}}', locationUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Retrieves a location details for a vehicle
     * @param vehicleUuid `string`
     */
    CarrentalService.prototype.getMapVehicleDetails = function (vehicleUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getMapVehicleDetails.replace('{{vehicleUuid}}', vehicleUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Performs a fleet-check for a vehicle
     * @param stationUuid `string`
     */
    CarrentalService.prototype.getFleetCheck = function (stationUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getFleetCheck.replace('{{stationUuid}}', stationUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Create a new zone
     */
    CarrentalService.prototype.postZone = function (data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.postZone;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Update an existing zone
     */
    CarrentalService.prototype.putZone = function (zoneUuid, data) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.putZone.replace('{{zoneUuid}}', zoneUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes an existing zone
     */
    CarrentalService.prototype.deleteZone = function (zoneUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.deleteZone.replace('{{zoneUuid}}', zoneUuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Retrieves a zones list related to a given station
     * @param stationUuid `string`
     */
    CarrentalService.prototype.getZones = function (stationUuid) {
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getZones.replace('{{stationUuid}}', stationUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a JSON with all vehicles to export
     * @param query {string}
     */
    CarrentalService.prototype.getVehicleExport = function (query) {
        if (query === void 0) { query = ''; }
        var url = carrental_const_1.CARRENTAL_ENDPOINT.getVehicleExport.replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates a vehicle status (active/inactive)
     * @param vehicleVin {string}
     * @param isActivation {boolean}
     */
    CarrentalService.prototype.putToggleActive = function (vehicleVin, isActivation) {
        if (isActivation === void 0) { isActivation = false; }
        var vehicleActionUrl = isActivation
            ? carrental_const_1.CARRENTAL_ENDPOINT.putActivateVehicle
            : carrental_const_1.CARRENTAL_ENDPOINT.putDeactivateVehicle;
        var url = vehicleActionUrl.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.put(url);
    };
    /**
     * Updates a vehicle fleet status (infleeted/defleeted)
     * @param vehicleVin {string}
     * @param isDefleeted {boolean}
     */
    CarrentalService.prototype.putToggleInfleeted = function (vehicleVin, isDefleeted) {
        if (isDefleeted === void 0) { isDefleeted = false; }
        var vehicleActionUrl = isDefleeted
            ? carrental_const_1.CARRENTAL_ENDPOINT.putDefleetVehicle
            : carrental_const_1.CARRENTAL_ENDPOINT.putInfleetVehicle;
        var url = vehicleActionUrl.replace('{{vehicleVin}}', vehicleVin);
        return axios_client_service_1.axiosClientInstance.put(url);
    };
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], CarrentalService.prototype, "postZone", null);
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String, Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], CarrentalService.prototype, "putZone", null);
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String]),
        tslib_1.__metadata("design:returntype", Promise)
    ], CarrentalService.prototype, "deleteZone", null);
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String]),
        tslib_1.__metadata("design:returntype", Promise)
    ], CarrentalService.prototype, "getZones", null);
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], CarrentalService.prototype, "getVehicleExport", null);
    return CarrentalService;
}());
/**
 * CarrentalService Class Instance
 * @namespace
 */
exports.carrental = new CarrentalService();
